import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useEffect, useState } from "react";
import classnames from "classnames";
import { Button } from "../../Button/index.js";
import { Icon } from "../../Icon/index.js";
import { useIsDesktop } from "../../hooks/index.js";
import { PreviewButtons } from "./Buttons/index.js";
import { useStyles } from "./Preview.styles.js";
const PreviewImage = (t0)=>{
    const $ = c(40);
    const { url, shape, clickable, onClickDownload, withCollapsableFooter, centerImage, onLoadSuccess, onExpand, onLoadFull, height, width, maxHeight, maxWidth } = t0;
    let t1;
    if ($[0] !== height || $[1] !== maxHeight || $[2] !== maxWidth || $[3] !== width) {
        t1 = {
            height,
            width,
            maxHeight,
            maxWidth
        };
        $[0] = height;
        $[1] = maxHeight;
        $[2] = maxWidth;
        $[3] = width;
        $[4] = t1;
    } else t1 = $[4];
    const { classes } = useStyles(t1);
    const isDesktop = useIsDesktop();
    const [objectUrl, setObjectUrl] = useState("");
    let t2;
    if ($[5] !== onLoadSuccess) {
        t2 = ()=>{
            if (onLoadSuccess) onLoadSuccess();
        };
        $[5] = onLoadSuccess;
        $[6] = t2;
    } else t2 = $[6];
    const handleImageLoad = t2;
    let t3;
    let t4;
    if ($[7] !== objectUrl) {
        t3 = ()=>()=>{
                if (objectUrl) URL.revokeObjectURL(objectUrl);
            };
        t4 = [
            objectUrl
        ];
        $[7] = objectUrl;
        $[8] = t3;
        $[9] = t4;
    } else {
        t3 = $[8];
        t4 = $[9];
    }
    useEffect(t3, t4);
    const t5 = "square" === shape && classes.image_square;
    let t6;
    if ($[10] !== classes.image || $[11] !== t5) {
        t6 = classnames(classes.image, t5);
        $[10] = classes.image;
        $[11] = t5;
        $[12] = t6;
    } else t6 = $[12];
    const imageClasses = t6;
    const t7 = centerImage && classes.centerImage;
    let t8;
    if ($[13] !== classes.collapseWrapper || $[14] !== classes.root || $[15] !== t7) {
        t8 = classnames(classes.root, classes.collapseWrapper, t7, "aqa_file_preview_image");
        $[13] = classes.collapseWrapper;
        $[14] = classes.root;
        $[15] = t7;
        $[16] = t8;
    } else t8 = $[16];
    let t9;
    if ($[17] !== classes.square || $[18] !== shape) {
        t9 = "square" === shape && /*#__PURE__*/ jsx("div", {
            className: classes.square
        });
        $[17] = classes.square;
        $[18] = shape;
        $[19] = t9;
    } else t9 = $[19];
    let t10;
    if ($[20] !== clickable || $[21] !== handleImageLoad || $[22] !== imageClasses || $[23] !== objectUrl || $[24] !== onLoadFull || $[25] !== url) {
        t10 = clickable ? /*#__PURE__*/ jsx("a", {
            href: url,
            onClick: (e)=>{
                if (onLoadFull) {
                    e.preventDefault();
                    e.stopPropagation();
                    onLoadFull().then((blob)=>{
                        const nextObjUrl = URL.createObjectURL(blob);
                        if (objectUrl) URL.revokeObjectURL(objectUrl);
                        setObjectUrl(nextObjUrl);
                        return nextObjUrl;
                    }).catch(()=>url).then(_temp);
                }
            },
            target: "_blank",
            rel: "noreferrer",
            children: /*#__PURE__*/ jsx("img", {
                className: imageClasses,
                src: url,
                alt: "",
                onLoad: handleImageLoad
            })
        }) : /*#__PURE__*/ jsx("img", {
            className: imageClasses,
            src: url,
            alt: "",
            onLoad: handleImageLoad
        });
        $[20] = clickable;
        $[21] = handleImageLoad;
        $[22] = imageClasses;
        $[23] = objectUrl;
        $[24] = onLoadFull;
        $[25] = url;
        $[26] = t10;
    } else t10 = $[26];
    let t11;
    if ($[27] !== onClickDownload || $[28] !== withCollapsableFooter) {
        t11 = onClickDownload && /*#__PURE__*/ jsx(PreviewButtons, {
            withCollapsableFooter: withCollapsableFooter,
            onClickDownload: onClickDownload
        });
        $[27] = onClickDownload;
        $[28] = withCollapsableFooter;
        $[29] = t11;
    } else t11 = $[29];
    let t12;
    if ($[30] !== classes.expandButton || $[31] !== isDesktop || $[32] !== onExpand) {
        t12 = onExpand && isDesktop && /*#__PURE__*/ jsx("div", {
            className: classes.expandButton,
            children: /*#__PURE__*/ jsx(Button, {
                icon: /*#__PURE__*/ jsx(Icon, {
                    name: "fullscreen_outline",
                    size: "20"
                }),
                size: "small",
                onClick: onExpand
            })
        });
        $[30] = classes.expandButton;
        $[31] = isDesktop;
        $[32] = onExpand;
        $[33] = t12;
    } else t12 = $[33];
    let t13;
    if ($[34] !== t10 || $[35] !== t11 || $[36] !== t12 || $[37] !== t8 || $[38] !== t9) {
        t13 = /*#__PURE__*/ jsxs("div", {
            className: t8,
            children: [
                t9,
                t10,
                t11,
                t12
            ]
        });
        $[34] = t10;
        $[35] = t11;
        $[36] = t12;
        $[37] = t8;
        $[38] = t9;
        $[39] = t13;
    } else t13 = $[39];
    return t13;
};
function _temp(objUrl) {
    window.open(objUrl, "_blank");
}
export { PreviewImage };
